<template>
	<div class="getReport">

		<div class="step">
			<div class="groupS">
				<el-row :gutter="24">
					<el-col :span="6">
						<div class="groupList">
							<span>預約日期：</span>
							<el-date-picker v-model="dateValue" value-format="timestamp" prefix-icon="clearDateIcon"
								type="daterange" range-separator="~" start-placeholder="開始日期" end-placeholder="結束日期">
							</el-date-picker>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="groupList">
							<span>訂單狀態：</span>
							<el-select v-model="appt_status" class="state status" placeholder="請選擇">
								<el-option v-for="item in statusList" class="state-option" :key="item.label"
									:label="item.value" :value="item.label">
								</el-option>
							</el-select>
						</div>
					</el-col>
					<el-col :span="5">
						<div style="display: flex; justify-content: flex-start;">
							<button class="nextBtn" style="margin-left: 0;" @click="getReport">搜索</button>
							<el-button @click="handleReset" style="margin-left: 0.2rem;" class="nextBtn">重置</el-button>
							<button type="submit" class="nextBtn" @click="downExcel">批量导出</button>
						</div>

					</el-col>

				</el-row>

				<div style="clear: both;"></div>
			</div>
		</div>
		<div class="step">
			<!-- <p class="stepTit">疫苗預約資訊</p> -->
			<el-table ref="multipleTable" :header-cell-style="{background:'#f0f3f8',color:'#333'}" :data="tableData"
				style="width: 100%" border>
				<el-table-column prop="id" label="編號" width="100">
				</el-table-column>
				<el-table-column prop="mobile" label="手機號">
				</el-table-column>
				<el-table-column prop="id_card" label="港澳通行證">
				</el-table-column>
				<el-table-column prop="goods_name" label="疫苗類型">
					<!-- <template slot-scope="scope">
					   <span style="color: #76838F;">{{scope.row.goods_id == '1' ? '复必泰二价' : scope.row.goods_id == '2' ? 'hpv九价' : '--' }}</span>
					</template> -->
				</el-table-column>
				<el-table-column prop="appt_addr" label="預約接種地點" width="500">
				</el-table-column>
				<el-table-column prop="appt_time" label="預約接種日期">
				</el-table-column>
				<el-table-column prop="appt_status" label="是否加急">
					<template slot-scope="scope">
						<span style="color: #76838F;">{{scope.row.fedex == '1' ? '是' : '否' }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="appt_status" label="訂單狀態">
					<template slot-scope="scope">
						<span class="status_1" v-if="scope.row.appt_status == '10'">已預約</span>
						<span class="status_80" v-if="scope.row.appt_status == '80'">已接種</span>
						<span class="status_90" v-if="scope.row.appt_status == '90'">已取消</span>
						<span class="status_71" v-if="scope.row.appt_status == '71'">已退款</span>
					</template>
				</el-table-column>
			</el-table>
			<el-row :gutter="20" v-show="downFile">
				<el-col :span="12">
					
					<form :action="http" method="post" autocomplete="off" v-show="false">
						<input type="text" name="startat" :value="dateValue ? dateValue[0] / 1000 : ''" />
						<input type="text" name="endat" :value="dateValue ? dateValue[1] / 1000 : ''" />
						<input type="text" name="appt_status" :value="appt_status" />
						<!-- <input type="text" name="ids" :value="tableData" /> -->
						<button type="submit" ref="down">批量导出</button>
					</form>
				</el-col>
			</el-row>
				<el-pagination
				prev-text="上一頁"
				next-text="下一頁" class="pagination" hide-on-single-page @current-change="handleCurrentChange"
					layout="total, prev, pager, next,jumper" :page-size="10" :total="pageCount">
				</el-pagination>
		</div>

		<Alert :hidden="alertShow" :tip-status="tipStatus" :tip-text="tipText" @on-close="closeDialog"
			@on-confirm="confirmDialog" />


	</div>
</template>

<script>
	import vaccin from '../assets/js/vaccin'

	import Alert from '../components/alert'
	export default {
		components: {
			Alert
		},
		name: "vaccin",
		...vaccin
	}
</script>

<style scoped>
	.getReport>>>.el-pager li.active {
		color: white;
		border-radius: 0.02rem;
		background: #6681FA !important;
	}

	.getReport>>>.el-range-editor.el-input__inner {
		float: left;
		width: 2.6rem;
		height: 0.36rem;
		line-height: 0.36rem !important;
		padding: 0;
	}

	.getReport>>>.el-date-editor .el-range-separator {
		line-height: 36px;
	}

	.getReport>>>.el-select {
		float: left;
	}

	.getReport>>>.el-pagination {
		text-align: center;
	}

	.editPopup>>>.el-select-dropdown__item {
		text-indent: 15px !important;
	}

	.editPopup>>>.el-input {
		margin-top: 0.07rem;
		display: block;
		float: left;
		width: 2.42rem;
		height: 0.4rem;
		font-size: 14px;
	}

	.editPopup>>>.el-input:last-child {
		float: right;
	}

	.editPopup>>>.el-input__icon {
		margin: 0  6px;
		line-height: 36px;
	}

	.editPopup>>>.el-input__inner {
		height: 0.4rem;
		border: 0.01rem solid rgba(213, 216, 222, 1);
		text-indent: 0.1rem;
		color: #C0C4CC;
	}

	.getReport>>>.el-range-input {
		font-size: 14px;
		line-height: 0.36rem;
	}

	.is-change>>>.el-input__inner,
	.is-change#areaSel {
		color: #40444D !important;
	}

	.state>>>.el-input__inner {
		font-size: 14px;
		height: 0.36rem;
		line-height: 0.36rem;
		width: 2rem;
	}

	.state>>>.el-input__icon {
		line-height: 36px;
	}

	.address>>>.el-input__inner {
		font-size: 14px;
		height: 0.36rem;
		line-height: 0.36rem;
		width: 2rem;
	}

	.status>>>.el-input__inner {
		font-size: 14px;
		height: 36px;
		line-height: 36px;
		width: 120px;
	}

	/* 设置邮箱弹出框 */
	.notice-alert>>>.el-dialog {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		margin: 0;
	}

	.notice-alert>>>.el-dialog__header {
		padding: 0;
	}

	.notice-alert>>>.el-dialog__body {
		padding: 0.24rem;
	}

	.notice-alert>>>.el-input input {
		height: 0.36rem;
		line-height: 0.36rem;
		margin-bottom: 0.08rem;
		padding: 0 0.08rem;
		font-weight: bold;
	}

	.notice-alert .emailNoticeVal>>>input {
		width: 7.08rem;
	}

	.notice-alert>>>#emailNoticeTel {
		display: inline-block;
		width: 3rem;
		margin-right: 0.09rem;
		vertical-align: top;
	}

	.notice-alert>>>#emailNoticeCode {
		width: 1.38rem;
		vertical-align: middle;
	}

	.notice-alert>>>.el-input-group__prepend {
		display: inline-block;
		width: 0.6rem;
		height: 0.35rem;
		padding: 0;
		background-color: #fff;
	}

	.notice-alert>>>.el-select__caret.el-input__icon {
		position: relative;
		height: 36px;
	}

	.notice-alert>>>.el-select__caret.el-input__icon:before {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		line-height: 36px;
	}

	.el-select-dropdown__item {
		padding: 0 0.08rem;
	}

	.notice-alert>>>.el-input.is-active .el-input__inner,
	.notice-alert>>>.el-input__inner:focus {
		border-color: #6681FA;
	}

	.status_1 {
		display: block;
		width: 0.5rem;
		text-align: center;
		padding: 0.02rem 0.1rem;
		border-radius: 4px;
		color: #fff;
		background-color: #5eb95e;
		box-sizing: content-box;
	}

	.status_80 {
		display: block;
		width: 0.5rem;
		text-align: center;
		padding: 0.02rem 0.1rem;
		border-radius: 4px;
		color: #fff;
		background-color: #6883FB;
		box-sizing: content-box;
	}

	.status_90 {
		display: block;
		width: 0.5rem;
		text-align: center;
		padding: 0.02rem 0.1rem;
		border-radius: 4px;
		color: #fff;
		background-color: rgba(255, 204, 26, 1);
		box-sizing: content-box;
	}

	.status_71 {
		display: block;
		width: 0.5rem;
		text-align: center;
		padding: 0.02rem 0.1rem;
		border-radius: 4px;
		color: #fff;
		background-color: #dd514c;
		box-sizing: content-box;
	}
	
	.pagination{
		padding-right: 24px;
		text-align: center;
		margin-top: 6px;
		background-color: #fff;
		display: flex;
		justify-content: flex-end;
	}
</style>
<style src="../assets/iconFonts/iconfont.css" scoped>
</style>
<style src="../assets/css/bookingInfo.css" scoped>

</style>